import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect, useContext } from 'react';
import { getInterviews } from '../../services/Interviews/interviewService';
import SmashLoader from '../../components/Loader/SmashLoader';
import InteviewCard from '../Interview/Inteviews/InteviewCard';
import { UserContext } from '../../utils/contexts/UserContext';
import { postSession } from '../../services/Interviews/sessionService';
import ChooseAgent from '../../components/Interview/ChooseAgent';
import { format, parseISO, isAfter } from 'date-fns';
import { toast } from 'react-toastify';

export default function UniversityInterviews() {
  const isDeadlinePassed = (deadline) => {
    if (!deadline) return false;
    try {
      const deadlineDate = parseISO(deadline);
      return !isAfter(deadlineDate, new Date());
    } catch (error) {
      return false;
    }
  };
  const { user } = useContext(UserContext);
  const { uuid } = useParams();
  const [interviews, setInterviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [interview, setInterview] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    getInterviews({
      params: {
        university: uuid,
      },
      signal: controller.signal,
    })
      .then((res) => {
        setInterviews(res.results);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        if (controller.signal.aborted) {
          return;
        }
        setLoading(false);
      });
    return () => controller.abort();
  }, [uuid]);

  if (loading) {
    return (
      <div>
        <SmashLoader />
      </div>
    );
  }

  return (
    <div>
      <h2
        className="text-3xl md:text-4xl font-bold mb-8 text-center
          text-gray-900 dark:text-white"
      >
        Interviews
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {interviews.map((interview) => (
          <div
            key={interview.uuid}
            className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6
                border border-gray-200 dark:border-gray-700
                transition-all duration-300 ease-in-out transform hover:scale-105"
          >
            <h3 className="text-2xl font-bold mb-2 text-gray-900 dark:text-white">
              {interview.name}
            </h3>
            <p className="text-gray-700 dark:text-gray-300 mb-4 leading-relaxed">
              {interview.description}
            </p>
            <div className="text-md mb-4">
              <p>
                <span className="font-semibold text-gray-700 dark:text-gray-300">
                  Questions:
                </span>{' '}
                {interview.questions_count}
              </p>
              <p>
                <span className="font-semibold text-gray-700 dark:text-gray-300">
                  Duration:
                </span>{' '}
                {Math.round(interview.questions_count * 1.6)} minutes
              </p>

              <p>
                <span className="font-semibold text-gray-700 dark:text-gray-300">
                  Status:
                </span>{' '}
                {interview.my_sessions?.find(
                  (session) => session.is_processed,
                ) ? (
                  <span>
                    Passed{' '}
                    {format(interview.my_sessions[0].created, 'dd.MM.yyyy')}
                  </span>
                ) : interview.my_sessions?.find(
                    (session) => !session.is_processed,
                  ) ? (
                  <span>In progress</span>
                ) : (
                  <span>Not started</span>
                )}
              </p>
              {interview.deadline && (
                <p>
                  <span className="font-semibold text-gray-700 dark:text-gray-300">
                    Deadline:
                  </span>{' '}
                  <span
                    className={
                      isDeadlinePassed(interview.deadline)
                        ? 'text-red-500 font-semibold'
                        : ''
                    }
                  >
                    {format(parseISO(interview.deadline), 'dd.MM.yyyy HH:mm')}
                    {isDeadlinePassed(interview.deadline) && ' (Passed)'}
                  </span>
                </p>
              )}
            </div>
            {!interview.my_sessions?.find(
              (session) => session.is_processed,
            ) && (
              <button
                onClick={() => {
                  if (isDeadlinePassed(interview.deadline)) {
                    toast.error('The deadline for this interview has passed');
                    return;
                  }
                  // if (user?.documents?.length === 0) {
                  //   toast.error('Please upload your identification document');
                  //   navigate('/profile/edit', {
                  //     state: {
                  //       tab: 'contact-info',
                  //     },
                  //   });
                  //   return;
                  // }
                  if (
                    interview.my_sessions?.find(
                      (session) => !session.is_processed,
                    )
                  ) {
                    const session = interview.my_sessions?.find(
                      (session) => !session.is_processed,
                    );
                    navigate(`/interviews/session/${session.uuid}`);
                    return;
                  }
                  setInterview(interview);
                  setIsOpen(true);
                }}
                disabled={isDeadlinePassed(interview.deadline)}
                className={`mt-4 w-full py-2 px-4 rounded-lg font-semibold transition duration-300 ease-in-out shadow-md
                  focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-75
                  ${
                    isDeadlinePassed(interview.deadline)
                      ? 'bg-gray-400 dark:bg-gray-600 text-gray-300 dark:text-gray-500 cursor-not-allowed'
                      : 'bg-purple-600 hover:bg-purple-700 text-white'
                  }`}
              >
                {isDeadlinePassed(interview.deadline)
                  ? 'Deadline Passed'
                  : 'Start Interview'}
              </button>
            )}
          </div>
        ))}
      </div>

      <ChooseAgent
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        interview={interview}
        user={user}
      />
    </div>
  );
}
